/* LUMANYC wordmark.

   Brief: one word, no spaces, LUMA heavy and NYC light, and NOT a generic UI font.
   Archivo read as system-default. Bricolage Grotesque has real character in the
   letterforms — a slightly squared bowl and a distinctive R/G — while still being a
   clean grotesque, which is the register premium skincare sits in (Allies, Theramid,
   Medik8 all use characterful grotesques rather than Helvetica clones).

   The two weights are set tight against each other with a hair of optical spacing, so
   LUMANYC reads as a single lockup rather than two words jammed together.
   Re-asserts on a content check so nothing can overwrite it. */
(function(){
function paint(){
  var br=document.querySelector('.lp .brand, .lh .brand'); if(!br) return;
  if(!document.getElementById('luma-brand-font')){
    var l=document.createElement('link');
    l.id='luma-brand-font'; l.rel='stylesheet';
    l.href='https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,200;12..96,300;12..96,700;12..96,800&display=swap';
    document.head.appendChild(l);
  }
  if(!document.getElementById('luma-brand-css')){
    var s=document.createElement('style'); s.id='luma-brand-css';
    s.textContent=
      '.lp .brand,.lh .brand{font-family:"Bricolage Grotesque",Archivo,Inter,-apple-system,Arial,sans-serif!important;'+
      'font-size:24px!important;line-height:1!important;white-space:nowrap!important;'+
      'display:inline-flex!important;align-items:baseline!important;gap:0!important;'+
      'letter-spacing:-.02em!important;font-variation-settings:"opsz" 40!important}'+
      '.lp .brand .lb1,.lh .brand .lb1{font-weight:800!important;letter-spacing:-.035em!important}'+
      '.lp .brand .lb2,.lh .brand .lb2{font-weight:200!important;letter-spacing:-.005em!important;margin-left:.06em!important}'+
      '@media(max-width:600px){.lp .brand,.lh .brand{font-size:20px!important}}';
    document.head.appendChild(s);
  }
  if(br.querySelector('.lb1')) return;
  var d=window.LUMA_NAV||{};
  br.innerHTML='<span class="lb1">'+(d.brand_line1||'LUMA')+'</span><span class="lb2">'+(d.brand_line2||'NYC')+'</span>';
}
document.addEventListener('DOMContentLoaded',function(){[60,400,900,1600].forEach(function(x){setTimeout(paint,x);});});
window.addEventListener('load',function(){[250,1200].forEach(function(x){setTimeout(paint,x);});});
})();